<template>
  <v-app id="systimes">
    <v-container>
      <v-row justify="center">
        <v-col md="6">
          <v-toolbar color="blue" dark>
            <v-app-bar-nav-icon to="/settings"></v-app-bar-nav-icon>
            <v-toolbar-title>
              SysTimes
              <span class="version">V.:&nbsp;{{ version }}</span>
            </v-toolbar-title>
          </v-toolbar>
        </v-col>
      </v-row>

      <v-row class="mt-6" justify="center">
        <v-col md="6">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import api from "./api.js";
import Cookies from "js-cookie";

export default {
  data: () => ({
    version: Cookies.get("version"),
  }),
  mounted() {
    this.$router.push("/Token");
    axios
      .post(api.URL() + "/api/v1/token", { token: Cookies.get("st3token") })
      .then((response) => {
        if (response.data == "OK") {
          this.$store.commit("setAuth", true);
          this.$router.push("/");
        }
        else {
          this.$store.commit("setAuth", false);
        }
      });
  },
  created() {
    console.log("Comprovant actualitzacions...");
    fetch(api.URL() + "/api/v1/version")
      .then((response) => {
        return response.json();
      })
      .then((version) => {
        console.log(version);
        if (Cookies.get("version") != version) {
          console.log("Actualitzo!");
          Cookies.set("version", version, {
            expires: 8000,
          });
          window.location.reload(true);
        }
      });
  }
};
</script>